import { render, staticRenderFns } from "./infoBanner.vue?vue&type=template&id=6d129924&scoped=true&"
import script from "./infoBanner.vue?vue&type=script&lang=js&"
export * from "./infoBanner.vue?vue&type=script&lang=js&"
import style0 from "./infoBanner.vue?vue&type=style&index=0&id=6d129924&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d129924",
  null
  
)

export default component.exports